import { announce } from '@/lib/announce';

interface OrnoToastOptions {
  action?: string;
  onAction?: () => void;
  duration?: number;
}

declare global {
  interface Window {
    /** orno.js's namespace; `toast` is its one imperative act. */
    Orno?: { toast?: (message: string, options?: OrnoToastOptions) => HTMLElement };
  }
}

function show(message: string): void {
  window.Orno?.toast?.(message);
}

/**
 * The short note at the foot of the page, through `Orno.toast` (a `role="status"` note that replaces the previous one
 * and goes after five seconds, or later while pointed at or focused). orno 2.1.0 has one kind of toast, so a failure
 * looks like a success; a failure is also said at once through the assertive live region (`announce`), because a
 * status note inserted with its text already in it is often not read.
 */
export const toast = {
  success: show,
  error: (message: string): void => {
    show(message);
    announce(message);
  },
};
